export default __webpack_public_path__ + "static/media/GameCover2.31e95346.jpg";